import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function FoodSafetyPolicy() {
  return (
    <PolicyPage title="Food Safety & Allergen Notice">
      <h2>General information</h2>
      <p>Food, storage, and serving information on this site is educational and does not replace a product label, recall notice, local health guidance, or advice from a qualified professional.</p>

      <h2>Ingredients and allergens</h2>
      <p>Always review the current label before purchase and consumption. Products may contain or contact common allergens, including milk, eggs, fish, shellfish, tree nuts, peanuts, wheat, soy, sesame, or other allergens. Recipes, suppliers, and production environments may change. Website information should not be your sole basis for managing a serious allergy.</p>

      <h2>Storage and handling</h2>
      <p>Follow the product's temperature, refrigeration, freezing, cleaning, and use-by instructions. Receive perishable deliveries promptly, wash hands and food-contact surfaces, prevent cross-contamination, and discard food that shows spoilage or has been held outside safe conditions.</p>

      <h2>Food-contact products</h2>
      <p>Wash food-contact items before first use. Use only within stated temperature and appliance limits. Unless a listing expressly says otherwise, do not assume a container is suitable for an oven, microwave, freezer, dishwasher, vacuum sealer, infant feeding, or hot liquids.</p>

      <h2>Pregnancy, health conditions, and vulnerable people</h2>
      <p>People who are pregnant, immunocompromised, very young, older, or managing a medical condition should follow relevant public-health advice and consult a qualified professional when unsure.</p>

      <h2>Recalls and safety concerns</h2>
      <p>If we become aware of a relevant recall or safety issue, we may use available order contact information to provide instructions. Stop using an affected product and follow the notice. Report a product-safety concern to <ContactEmail /> with the product, order number, batch or label details, and photographs.</p>
    </PolicyPage>
  );
}

export default FoodSafetyPolicy;
